import React, { FC, Fragment, useMemo } from 'react';

import { useRoutesWithBreadcrumbs } from '../../context';
import { Error404 } from '../ErrorPages';
import { Languages } from './pages';

export const LanguagesEntrypoint: FC = () => {
  const routesConfig = useMemo(() => [
    {
      label: 'Devices',
      element: <Languages />,
      path: '/',
    },
    {
      path: '/*',
      element: <Error404 />,
    },
  ], []);

  const routes = useRoutesWithBreadcrumbs(routesConfig);

  return (
    <Fragment key="routes">{routes}</Fragment>
  );
};
